module.exports = __webpack_public_path__ + "kishoralo-de7140d18bc012e6cfae.svg";